function VcaUi({ moduleId }) {
  return null;
}

export default VcaUi;
